export default {
  data() {
    return {
      tableLoading: false,
      tableData: [],
      tableHead: [],
      queryParams: {},
      pageNum: 1,
      pageSize: 10,
      total: 0,
    };
  },
  created() { 
    this.uploadParams();
  },
  methods: {
    // 获取数据序号
    getColumnIndex(index) {
      try {
        return (Number(this.pageNum) - 1) * Number(this.pageSize) + index + 1;
      } catch (error) {
        return index + 1;
      }
    },
    // 保存搜索记录数据
    getSetItem() {
      sessionStorage.setItem(this.type, JSON.stringify(this.getParams()));
    },
    // 获取搜索记录数据
    getGetItem() {
      return sessionStorage.getItem(this.type) ? JSON.parse(sessionStorage.getItem(this.type)) : {}
    },
    // 移除搜索记录数据
    removeItem(type) {
      sessionStorage.removeItem(type);
    },
    // 重定义搜索数据
    uploadParams() {
      var paramList = {}
      paramList = this.getGetItem();
      if (Object.keys(paramList).length > 0) {
        this.queryParams = {...this.queryParams, ...paramList.data}
        this.pageNum = paramList.page.pageNum;
        this.pageSize = paramList.page.pageSize;
      }
    },
    // 获取查询参数
    getParams() {
      return {
        data: {
          ...this.queryParams
        },
        page: {
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }
      };
    },
    // 检索，重置页码
    doSearch() {
      this.pageNum = 1;
      this.getSetItem(this.type);
      this.getList();
    },

    // 翻页
    handlePaginationChange({ page, limit }) {
      this.pageNum = page;
      this.pageSize = limit;
      this.getList();
    },

    // 重置查询条件
    handleResetQuery() {
      // 移除搜索数据
      sessionStorage.removeItem(this.type);
      this.queryParams = Object.assign({}, this.$options.data()?.queryParams);
      this.doSearch();
    },

    // 列表查询
    async getList() {
      this.beforeGetList && this.beforeGetList();
      if (typeof this.listMethod !== "function") {
        throw new Error("miss listMethod");
      }
      this.tableLoading = true;
      try {
        const res = await this.listMethod(this.getParams());
        if (res.status === "0") {
          let resData = [];
          let resTotal = 0;
          if (Array.isArray(res.data)) {
            resData = res.data;
          } else {
            resData = res.data?.records || [];
            resTotal = res.data?.count || 0;
          }
          this.tableHead = res.data?.head || [];
          this.tableData =
            typeof this.formatTableData === "function"
              ? this.formatTableData(resData)
              : resData;
          this.total = resTotal;
        } else {
          this.tableData = [];
        }
        this.getTableHighest(this, "maxHeight");
      } catch (error) {
        this.tableData = [];
        console.error(error);
      }
      this.tableLoading = false;
      this.afterGetList && this.afterGetList();
    },

    // 删除表格数据（表格只有一条记录时，向前翻一页）
    handleDeleteTableData(delNum = 1) {
      if (this.tableData.length === delNum && this.pageNum > 1) {
        this.pageNum = this.pageNum - 1;
      }
    },
  },
};
